import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

const HumanoidModel = () => {
    const { scene } = useGLTF('/models/humanoid_final.glb'); // Path to your humanoid model

    return (
        <Canvas style={{ height: '100vh', width: '100vw' }}>
            <Suspense fallback={<p>Loading humanoid...</p>}>
                <ambientLight intensity={0.5} />
                <directionalLight position={[2, 5, 2]} />
                <OrbitControls />
                <primitive object={scene} />
            </Suspense>
        </Canvas>
    );
};

export default HumanoidModel;

